





































































import AbpBase from "@/lib/abpbase";
import Util from "@/lib/util";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {GetEnvironmentJcList, InsertEnvironmentJc, UpdateEnvironmentJcById, DeleteEnvironmentJc} from '../../../api/engineer'
import {GetPinYin, GetWuBi} from '../../../api/sys'

@Component
export default class Environment extends AbpBase {
	cancel(){
		this.dialogFormVisible = false
	}
	visibleChange(value: boolean) {
		if (!value) {
			this.dialogFormVisible = false;
			(this.$refs.form as any).resetFields()
			this.getData()
		}
	}
	dateRangeChange(event:any){
		this.dateRange = event
		this.getData()
	}
	columns = [
		{
			key: 'detectionDate',
			title: '时间',
			render:(h:any, p:any)=>{
				return h('span', this.formatDate(p.row.detectionDate))
			}
		},
		{
			key: 'jcItem',
			title: '检测项'
		},
		{
			key: 'jcResult',
			title: '检测结果',
			render:(h:any, p:any)=>{
				return h('span',{
					style:{
						color: p.row.jcResult > 200 ? 'red' : ''
					}
				},p.row.jcResult + ' cfu/ml')
			}
		},

		{
			key: '',
			width: 190,
			title: '操作',
			render:(h:any, p:any)=>{
				return h('div', [
					h('Button',{
						props:{type: 'primary'},
						style:{marginRight:'20px'},
						on:{
							click:()=>{
								this.edit(p.row)
							}
						}
					},'编辑'),
					h('Button',{
						props:{type: 'error'},
						on:{
							click:()=>{
								this.del(p.row)
							}
						}
					},'删除'),
				])
			}
		},
	]
	key = '' //查询条件
	page = 1 //当前页
	dialogTitle = ''
	dialogForm: any = {}
	dialogFormVisible = false
	dialogFormLabelWidth = '100px'
	tableTotalSize = 0
	tableData = []
	tableLoading = false
	util = Util
	dateRange = []
	status: any = ''
	created() {
		const end = new Date();
		const start = new Date();
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		this.dateRange = [start, end]
		this.getData()
	}

	//获取拼音五笔
	async getCode(val: any) {
		let query = {inputStr: val}
		let res1 = await GetPinYin(query)
		let res2 = await GetWuBi(query)
		this.dialogForm.countryPY = res1
		this.dialogForm.countryWB = res2
	}

	createCounty() {
		this.dialogTitle = '新增环境管理'
		this.dialogForm = {status: true, countryWB: '', countryPY: ''}
		this.dialogFormVisible = true
	}

	private async getData() {
		this.tableLoading = true
		let res = await GetEnvironmentJcList({
			QueryString: this.key,
			StDate:this.dateRange[0],
			EnDate:this.dateRange[1],
			Status: this.status,
			SkipCount: this.page,
			MaxResultCount: 10
		})
		this.tableData = res.items
		this.tableTotalSize = res.totalCount
		this.tableLoading = false
	}

	handleClose() {
		this.dialogFormVisible = false
	}

	edit(row: any) {
		this.dialogTitle = '编辑环境管理'
		this.dialogForm = JSON.parse(JSON.stringify(row))
		this.dialogFormVisible = true
	}

	async del(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeleteEnvironmentJc({Id: row.id})
			this.getData()
		}).catch(() => {

		});

	}

	async confirm() {
		(this.$refs.form as any).validate(async (valid:boolean)=>{
			if(valid){
				if (this.dialogTitle === '新增环境管理') {
					let res = await InsertEnvironmentJc(this.dialogForm)
				} else if (this.dialogTitle === '编辑环境管理') {
					let res = await UpdateEnvironmentJcById(this.dialogForm)
				}
				this.dialogFormVisible = false
				this.getData()
			}
		})
	}

	rules = {
		detectionDate: [{required: true, message: '请输入内容', trigger: 'blur'}],
		jcItem: [{required: true, message: '请输入内容', trigger: 'blur'}],
		jcResult: [{required: true, message: '请输入内容', trigger: 'blur'}],
	}

	pageChange(val: any) {
		this.page = val
		this.getData()
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/engineer/environment/index.vue